module.exports = __webpack_public_path__ + "img/e515d4d749d54d839f1668a87f77772d.112a14d5.png";